(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletDeleteController',TabletDeleteController);

    TabletDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tablet'];

    function TabletDeleteController($uibModalInstance, entity, Tablet) {
        var vm = this;

        vm.tablet = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tablet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
